import React from 'react';
import { Container } from 'react-bootstrap';
import './assets/css/style.css';

export default function BackAnimation() {

    return (
        <div className='hero-solution hero-solution-wrap' id="wrap">
            <div className="main-wrap">
                <div class='wrap'>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                    <div class='c'></div>
                </div>
            </div>
        </div>
    );

}